export default __webpack_public_path__ + "static/media/landing-fielding-views.6b2174f8.png";